module.exports = __webpack_public_path__ + "static/media/bfile-golf_cart.ed11b989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-golf_cart.svg
// module id = 555
// module chunks = 0